import React from 'react'

const ControlFillRateContainer = () => (
  <>
  

    <iframe
      title="Fill Rate"
      width="100%"
      height="90%"
      src="https://app.powerbi.com/reportEmbed?reportId=d8afb217-ca22-4707-8bd3-6d7fe3864447&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
      frameBorder="0"
      allowFullScreen="true"
      />
  </>
)

export default ControlFillRateContainer
